(function() {
    'use strict';

    angular.module('app.categorias', []);
})();
